/* eslint-disable indent */
export default class IndicationSelectionTableRowSkeletonHtml {
    // eslint-disable-next-line class-methods-use-this
    toString() {
        return `
            <tr class="rfct-indication-selection-skeleton__table-tr">
                <td class="rfct-indication-selection-skeleton__table-td">
                    <div class="rfct-indication-selection-skeleton__product-info">
                        <div class="rfct-indication-selection-skeleton__product-ref">
                            <div class="ph-item ph-row">
                                <div class="ph-col-6"></div>
                                <div class="ph-col-6 empty"></div>
                                <div class="ph-col-3"></div>
                            </div>
                        </div>
                    </div>
                </td>
                <td class="rfct-indication-selection-skeleton__table-td">
                    <div class="rfct-indication-selection-skeleton__rec-quantity">
                        <div class="ph-item ph-row">
                            <div class="ph-col-4 empty"></div>
                            <div class="ph-col-4"></div>
                            <div class="ph-col-4 empty"></div>
                        </div>
                    </div>
                </td>
                <td class="rfct-indication-selection-skeleton__table-td">
                    <div class="rfct-indication-selection-skeleton__quantity"> <!-- TODO add skeleton for quantity input, but idk how it should look -->
                        <div class="ph-item ph-row">
                            <div class="ph-col-2 big"></div>
                            <div class="ph-col-1 big empty"></div>
                            <div class="ph-col-4 big"></div>
                            <div class="ph-col-1 big empty"></div>
                            <div class="ph-col-2 big"></div>
                        </div>
                    </div>
                </td>
                <td class="rfct-indication-selection-skeleton__table-td">
                    <div class="rfct-indication-selection-skeleton__action">
                        <div class="rfct-indication-selection-skeleton__action-button-container">
                            <div class="ph-item ph-row">
                                <div class="ph-col-6"></div>
                            </div>
                        </div>
                        <div class="rfct-indication-selection-skeleton__action-button-container">
                            <div class="ph-item ph-row">
                                <div class="ph-col-6"></div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>`;
    }
}
